import { FullUser } from '../../../models/full-user.model';
import { Group } from '../../../models/group.model';
import { GroupContext } from '../../../models/group-context.model';
import { User } from '../../../models/user.model';
import { DealPayrollGradeCode, PayrollCalculationMethod } from '../../../models/deal-payroll.model';
import { CurrencyCode } from '../../../models/payroll-currency.model';
import { PublicAbsenceStatus } from '../../common/vacation/vacation-api.constants';

export interface VacationPresenceByUserId {
	[userId: string]: PublicAbsenceStatus;
}

export interface DepartmentPayrollCurrencyUpdate {
	groupId: string;
	requestedCurrency: CurrencyCode;
}

export interface SortCriterion {
	userOrder: string;
	order: string;
}

export interface SortState {
	[userOrder: string]: string;
}

export interface SortIndexByUserOrder {
	[userOrder: string]: number;
}

export interface VectorUserListResponse {
	body: {
		users: ViewGroupVectorUser[];
	};
}

export interface ViewGroupVectorUser {
	user: ViewGroupVectorEmployee;
	currentGrade?: DealPayrollGradeCode;
	currentGradeStatus?: 'AVAILABLE' | 'UNASSIGNED' | 'UPDATING' | 'UNAVAILABLE';
	currentGradeLabelKey?: string;
	payrollCalculationMethod?: PayrollCalculationMethod;
	canEditVector?: boolean;
	isUserSelected?: boolean;
	vector?: ViewGroupVectorHistory;
	shift?: ViewGroupShiftState;
	currentShiftLabel?: ViewGroupShiftLabel;
	plannedShiftLabel?: ViewGroupShiftLabel;
	probation?: {approved: boolean; approvedAt?: string; canApproveDuringDeployment?: boolean; windowExpiresAt?: string};
}

export type ViewGroupShiftLabel = '1' | '2' | '3' | 'F';
export type ViewGroupShiftKind = 'current' | 'planned';

export interface ViewGroupScheduleSlots {
	id: string;
	workSchedule?: ViewGroupShiftSchedule;
	workScheduleId2?: ViewGroupShiftSchedule;
	workScheduleId3?: ViewGroupShiftSchedule;
	flexibleWorkSchedule?: ViewGroupShiftSchedule[];
}

export interface ViewGroupVectorEmployee extends FullUser {
	fullNativeName?: string;
}

export interface ViewGroupVectorHistory {
	current?: ViewGroupVectorSnapshot;
	previous?: ViewGroupVectorSnapshot;
}

export interface ViewGroupVectorSnapshot {
	components: number[];
}

export interface ViewGroupShiftState {
	current?: ViewGroupShiftAssignment;
	planned?: ViewGroupShiftAssignment;
}

export interface ViewGroupShiftAssignment {
	schedule?: ViewGroupShiftSchedule;
	from?: string;
}

export interface ViewGroupShiftSchedule extends ScheduleTitleRecord {
	id?: string | number;
	type?: string;
}

export interface SelectableGroupMember {
	isUserSelected: boolean;
}

export interface ClosableOverlay {
	close(): void;
}

export interface ScheduleTitleSegment {
	workDays: string | number;
	restDays: string | number;
}

export interface ScheduleTitleRecord {
	workStart?: string;
	workEnd?: string;
	segments?: ScheduleTitleSegment[];
}

export interface ViewGroupIdentityContext {
	group: Group;
	groupContext?: GroupContext;
	user: User;
	isAdmin: boolean;
	isHead: boolean;
	isHeadOfGroup: boolean;
	isDeputy: boolean;
}

export interface ViewGroupUiStateSnapshot {
	mobWidth: number;
	dataListVector: Object[];
	suc: boolean;
	nodata: boolean;
}

export type ViewGroupReloadTarget = string;

export interface ViewGroupMemberDeletionRequest {
	userId: string | number;
	groupId: string;
}

export interface ViewGroupMemberActionRequest extends ViewGroupMemberDeletionRequest {
	viewGroupId: string;
	action: string;
}

export const VIEW_GROUP_MEMBER_ACTIONS = { DELETE: 'delete', SHIFT: 'shift' };



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-group/view-group.types.ts